(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-product-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-look-carousel')) {
    customElements.define(
      'cb-look-carousel',
      class CbLookCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-look-track]');
          this.prev = this.querySelector('[data-look-prev]');
          this.next = this.querySelector('[data-look-next]');
          if (!this.track) return;

          this._onScroll = () => this.update();
          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', this._onScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this._ro = new ResizeObserver(() => this.update());
            this._ro.observe(this.track);
          } else {
            window.addEventListener('resize', this._onScroll);
          }
          this.update();
        }

        disconnectedCallback() {
          this._ro && this._ro.disconnect();
          window.removeEventListener('resize', this._onScroll);
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          if (this.prev) this.prev.disabled = x <= 4;
          if (this.next) this.next.disabled = x >= max - 4;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-recommendations')) {
    customElements.define(
      'cb-recommendations',
      class CbRecommendations extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-cb-track]');
          this.prev = this.querySelector('[data-cb-prev]');
          this.next = this.querySelector('[data-cb-next]');
          if (!this.track) return;

          this._onScroll = () => this.update();
          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', this._onScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this._ro = new ResizeObserver(() => this.update());
            this._ro.observe(this.track);
          } else {
            window.addEventListener('resize', this._onScroll);
          }

          this.update();
        }

        disconnectedCallback() {
          this._ro && this._ro.disconnect();
          window.removeEventListener('resize', this._onScroll);
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          const scrollable = max > 4;
          this.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
          if (this.prev) this.prev.disabled = x <= 4;
          if (this.next) this.next.disabled = x >= max - 4;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-reviews-wall"] && !Shopify.designMode) return;
  try {
    
  class CBReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cb-rw__track');
      this.prev = this.querySelector('[data-dir="prev"]');
      this.next = this.querySelector('[data-dir="next"]');
      this.dots = this.querySelector('[data-dots]');
      if (!this.track) return;

      const photoCards = Array.from(this.track.querySelectorAll('.cb-rw__card--photo'));
      const textCards = Array.from(this.track.querySelectorAll('[data-review-card]:not(.cb-rw__card--photo)'));
      this.track.replaceChildren(...photoCards, ...textCards);
      this.cards = Array.from(this.track.querySelectorAll('[data-review-card]'));
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setAttribute('data-scrollable', this.cards.length > 1 ? 'true' : 'false');

      this.prev && this.prev.addEventListener('click', () => this.go(-1, true));
      this.next && this.next.addEventListener('click', () => this.go(1, true));
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      });

      this._visibility = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();
      document.addEventListener('visibilitychange', this._visibility);

      this._touchStart = 0;
      this.track.addEventListener('touchstart', (event) => {
        this._touchStart = event.touches[0]?.clientX || 0;
        this.stopAutoplay();
      }, { passive: true });
      this.track.addEventListener('touchend', (event) => {
        const end = event.changedTouches[0]?.clientX || 0;
        const distance = end - this._touchStart;
        if (Math.abs(distance) > 45) this.go(distance < 0 ? 1 : -1, true);
        else this.startAutoplay();
      }, { passive: true });

      this._resize = () => this.syncHeight();
      window.addEventListener('resize', this._resize);

      this.render();
      this.startAutoplay();

      this.initModal();
      this.initLightbox();
    }

    initLightbox() {
      this.lightbox = this.querySelector('[data-review-lightbox]');
      if (!this.lightbox) return;
      const lbImg = this.lightbox.querySelector('[data-lightbox-img]');

      this._openLightbox = (btn) => {
        const src = btn.getAttribute('data-full-src');
        const img = btn.querySelector('img');
        if (!src) return;
        this.stopAutoplay();
        lbImg.src = src;
        lbImg.alt = img ? img.alt : '';
        this.lightbox.hidden = false;
        this.lightbox.classList.add('is-open');
        // forzar reflow para la transición de opacidad
        void this.lightbox.offsetWidth;
        this.lightbox.classList.add('is-visible');
        document.documentElement.style.overflow = 'hidden';
      };
      this._closeLightbox = () => {
        this.lightbox.classList.remove('is-visible');
        document.documentElement.style.overflow = '';
        setTimeout(() => {
          this.lightbox.classList.remove('is-open');
          this.lightbox.hidden = true;
          lbImg.src = '';
          this.startAutoplay();
        }, 220);
      };

      this.querySelectorAll('[data-review-photo]').forEach((btn) =>
        btn.addEventListener('click', () => this._openLightbox(btn))
      );
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox || e.target.closest('[data-lightbox-close]')) this._closeLightbox();
      });
      this._lbKey = (e) => { if (e.key === 'Escape' && !this.lightbox.hidden) this._closeLightbox(); };
      document.addEventListener('keydown', this._lbKey);
    }

    go(step, userInitiated = false) {
      if (this.cards.length < 2) return;
      this.index = (this.index + step + this.cards.length) % this.cards.length;
      this.render();
      if (userInitiated) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    render() {
      const total = this.cards.length;
      this.cards.forEach((card, cardIndex) => {
        const distance = (cardIndex - this.index + total) % total;
        const active = distance === 0;
        card.classList.toggle('is-active', active);
        card.classList.toggle('is-next', distance === 1);
        card.classList.toggle('is-after-next', distance === 2);
        card.setAttribute('aria-hidden', active ? 'false' : 'true');
        card.toggleAttribute('inert', !active);
      });
      if (this.dots) this.dots.textContent = `${this.index + 1} / ${total}`;
      if (this.prev) this.prev.disabled = total < 2;
      if (this.next) this.next.disabled = total < 2;
      this.syncHeight();
    }

    syncHeight() {
      const active = this.cards?.[this.index];
      if (!active) return;
      requestAnimationFrame(() => {
        this.track.style.height = `${active.offsetHeight + 32}px`;
      });
    }

    startAutoplay() {
      if (this.reducedMotion || document.hidden || this.cards.length < 2) return;
      this.stopAutoplay();
      this._autoplay = window.setInterval(() => this.go(1), 5500);
    }

    stopAutoplay() {
      if (this._autoplay) window.clearInterval(this._autoplay);
      this._autoplay = null;
    }

    /* ---- Modal escribir reseña ---- */
    initModal() {
      this.modal = this.querySelector('[data-review-modal]');
      if (!this.modal) return;

      this.querySelectorAll('[data-open-review]').forEach((b) =>
        b.addEventListener('click', () => this.openModal())
      );
      this.modal.querySelectorAll('[data-close-review]').forEach((b) =>
        b.addEventListener('click', () => this.closeModal())
      );
      this._onKey = (e) => { if (e.key === 'Escape') this.closeModal(); };

      this.initRating();

      if (this.modal.querySelector('[data-review-posted]')) {
        this.openModal(true);
      }
    }

    initRating() {
      const wrap = this.modal.querySelector('[data-rate]');
      if (!wrap) return;
      const stars = Array.from(wrap.querySelectorAll('[data-rate-star]'));
      const inputs = Array.from(wrap.querySelectorAll('[data-rate-input]'));
      const paint = (n) => stars.forEach((s) => s.classList.toggle('is-on', +s.dataset.rateStar <= n));
      const checked = () => {
        const c = inputs.find((i) => i.checked);
        return c ? +c.dataset.rateInput : 0;
      };
      stars.forEach((s) => {
        s.addEventListener('mouseenter', () => paint(+s.dataset.rateStar));
      });
      inputs.forEach((i) => i.addEventListener('change', () => paint(checked())));
      wrap.addEventListener('mouseleave', () => paint(checked()));
      paint(checked());
    }

    openModal(skipFocus) {
      if (!this.modal) return;
      this.stopAutoplay();
      this.modal.hidden = false;
      document.body.classList.add('cb-rw-modal-open');
      document.addEventListener('keydown', this._onKey);
      if (!skipFocus) {
        const f = this.modal.querySelector('input, textarea, button.cb-rw__submit');
        if (f) f.focus();
      }
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.classList.remove('cb-rw-modal-open');
      document.removeEventListener('keydown', this._onKey);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this._resize) window.removeEventListener('resize', this._resize);
      if (this._visibility) document.removeEventListener('visibilitychange', this._visibility);
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      if (this._lbKey) document.removeEventListener('keydown', this._lbKey);
      document.body.classList.remove('cb-rw-modal-open');
      document.documentElement.style.overflow = '';
    }
  }
  if (!customElements.get('cb-reviews')) customElements.define('cb-reviews', CBReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-camelia-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-camelia-countdown]');
    if (!root) return;
    const output = root.querySelector('[data-camelia-time]');
    const hours = Number(root.dataset.hours || 10);
    const key = 'camelia-countdown-end';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end <= Date.now()) {
      end = Date.now() + hours * 60 * 60 * 1000;
      sessionStorage.setItem(key, String(end));
    }
    const render = () => {
      const remaining = Math.max(0, end - Date.now());
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      output.textContent = `${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`;
    };
    render();
    window.setInterval(render, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
